var map = {
  "./bf-banner-bg.png": "9823",
  "./black-background.jpg": "4080",
  "./brands-icon-sprite.svg": "7411",
  "./cybermonday-banner-bg.jpg": "4554",
  "./cybermonday-bg.jpg": "1843",
  "./cybermonday-logo.png": "4515",
  "./cybermonday-pattern.jpg": "1370",
  "./electronics-icon.svg": "9928",
  "./fashion-icon.svg": "4587",
  "./feather-sprite.svg": "48",
  "./feature_img_1.jpg": "2281",
  "./feature_img_2.jpg": "2433",
  "./feature_img_3.jpg": "3908",
  "./feature_img_4.jpg": "5871",
  "./feature_img_5.jpg": "9522",
  "./heart-logo.png": "9370",
  "./hero.jpg": "9106",
  "./logo-qr-coupon--flat-2016.svg": "7778",
  "./logo-qr-coupon--simple-2019.svg": "336",
  "./sale-tag.svg": "2171",
  "./sale.png": "8939",
  "./samwise_logo.png": "5104",
  "./shop-fallback.png": "4591",
  "./site-logo.png": "5475",
  "./sprite-two.png": "2232",
  "./teaser-label.png": "3647",
  "./xmas-bg.jpg": "679",
  "./xmas-boxes.png": "2843",
  "./xmas-sale-label.png": "94"
};


function __rspack_context(req) {
  var id = __rspack_context_resolve(req);
  return __webpack_require__(id);
}
function __rspack_context_resolve(req) {
  if(!__webpack_require__.o(map, req)) {
    var e = new Error("Cannot find module '" + req + "'");
    e.code = 'MODULE_NOT_FOUND';
    throw e;
  }
  return map[req];
}
__rspack_context.keys = function() { return Object.keys(map); };
__rspack_context.resolve = __rspack_context_resolve;
module.exports = __rspack_context;
__rspack_context.id = 5766;
